<!-- PredictResult V2 -->
<h2 class="mt-3 ml-5">Predict Result</h2>
<hr>

<div class="main" *ngIf="predictJsonObject | async as resp">
    <!-- Bu kısımda bir container-div kullanarak içerisinde ana görselimiz ve üzerine de bordersları döngü ile çizdiriyoruz -->
    <!-- img elementi css tarafında manuel olarak 650px olarak ayarlandı. Hasan abi böyle olmasını istedi. -->

    <div class="container-div">
        <!--Image alanı-->
        <ng-container *ngIf="imageUrl | async as photo">
            <img id="photo" #myImage [src]="photo" (load)="getImageSize(myImage)" />
        </ng-container>
        <!--Image alanı sonu-->

        <!--Borders alanı-->
        <ng-container>
			<ng-container>
                <div *ngFor="let summary of labelSummaries.value| keyvalue; let i = index">
                    <div *ngFor="let border of resp.predict_results">
                        <div *ngIf="checkSummaryAndTagname(summary.key, border.tagname) === true">
                            <div *ngIf="border.isSelected">
                                <div class="product-border" [ngClass]="border.isSelected ? getBorderColorClass(i) : 'border-decline'" [ngStyle]="getBorderStyle(border)" (click)="toggleSelection(border)">
                                    <label [ngClass]="border.isSelected ? getLabelColorClass(i) : 'label-decline'"
                                        >{{ border.tagname.split(" ") }}
                                        <span class="tooltip-text">{{ border.tagname }}-{{ border.probability }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</ng-container>
        </ng-container>
        <!--Borders alanı sonu-->
    </div>

    <div class="row">
        <div class="col-12">
            <ng-container>
                <!--Bu kısımda görsel üzerindeki borderlara ait bilgiler tablo halinde gösterilir.-->
                <table class="table table-bordered mt-3">
                    <thead>
                        <tr>
                            <th>Label</th>
                            <th>Ürün Miktarı</th>
                            <th>Toplam Ürün Miktarına Oranı</th>
                            <th>Geribildirim Açıklama</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let summary of displayedLabelSummaries.value | keyvalue">
                        <tr>
                            <td>{{ summary.key }}</td>
                            <td>{{ summary.value }}</td>
                            <td>% {{ calcPercentage(summary.value) }}</td>
                            <td><input type="text" 
                                placeholder="Yorumunuzu girin.." 
                                class="form-control"
                                           
                                [value]="feedbackMap[summary.key]?.comment || ''"
                                (input)="updateFeedback(summary.key, $event.target.value)"></td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>

        <div class="col-12">
            <ng-container>
              
                <textarea 
                class="form-control" 
                id="exampleFormControlTextarea1" 
                rows="4"
                (input)="updateGlobalFeedback($event.target.value)"
                placeholder="Genel Geribildirim.."></textarea>
                <!-- <button type="button" class="btn btn-success btn-sm" style="margin-top: 30px;">Geribildirim Gönder</button> -->
            </ng-container>
        </div>

        <div class="col-12">
            <ng-container>
                <!--Bu kısımda görsel üzerindeki borderları görselin yanında labelSummary başlığına göre liste liste gösteriyoruz.-->
                <div class="row">
                    <div class="col-12 mt-4">
                        <div class="row">
                            <div class="col-3">
                                <button type="button" class="btn btn-primary btn-sm" (click)="changeBorderVisible()">
                                    <span *ngIf="isVisible == true">Tüm Seçimi Kaldır</span>
                                    <span *ngIf="isVisible == false">Hepsini Seç</span>
                                </button>
                            </div>
                            <div class="col-7">&nbsp;</div>
                            <div class="col-2">
                                <button type="button" class="btn btn-success btn-sm" (click)="sendFeedbackText()">
                                    <!-- <span *ngIf="(isFormSending | async) == false">Geribildirimi Gönder</span> -->
                                     <span>Geribildirimi Gönder</span>
                                </button>
                            </div>                            
                            <div class="col-3">
                                <!--URL parametresinde 0 gelirse Formu Gonder buton gözükmesin-->
                                <div *ngIf="formButtonIsVisible != 0">
                                    <button type="button" class="btn btn-success btn-sm" (click)="sendApprovedBorder()" [disabled]="(isFormSending | async) == true">
                                        <span *ngIf="(isFormSending | async) == true">Kaydediliyor...</span>
                                        <span *ngIf="(isFormSending | async) == false">Formu Gönder</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="row">
                            <div class="col-auto" *ngFor="let summary of labelSummaries.value | keyvalue">
                                
                                <label><b>{{ summary.key }} :</b> </label><label class="kt-badge kt-badge--md kt-badge--rounded kt-badge--bold kt-font-primary"> {{ summary.value }}</label>

                                <div class="checkboxes" *ngFor="let border of resp.predict_results">
                                  
                                    <div *ngIf="checkSummaryAndTagname(summary.key, border.tagname) === true">
                                        <input type="checkbox" [(ngModel)]="border.isSelected" (change)="onCheckboxChange(border)" />
                                       
                                        <!-- border.isExcluded, kontrol fonksiyonu tarafindan devre disi birakilan boxlardir. -->
                                       
                                        <ng-container *ngIf="border.isExcluded == true">
                                           <span style="color: red;"> {{ border.tagname }}-{{ border.probability }} </span>
                                        </ng-container>

                                        <ng-container *ngIf="! border.isExcluded" >
                                            {{ border.tagname }}-{{ border.probability }}
                                        </ng-container>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
